<template>
  <v-card>
    <v-card-title class="headline" dark-title>
      <span v-if="clientName !== undefined">
        Products List of {{ clientName }}
      </span>
      <span v-else>
        Products List
      </span>
      <!-- {{ $store.getters.selected_client_name }} -->
      <v-spacer></v-spacer>
      <v-autocomplete
        :items="brands"
        v-model="selected_brand"
        item-text="name"
        item-value="id"
        outlined
        label="Filter By Brand"
        hide-details
        class="autocom-width me-1"
        clearable
        dense
      ></v-autocomplete>
      <v-text-field
        v-model="searchFor"
        label="Search Product"
        outlined
        hide-details
        append-icon="mdi-magnify"
        dense
      ></v-text-field>
    </v-card-title>
    <v-card-text class="">
      <ex-card disable-offsets>
        <template>
          <v-data-table
            v-model="selected_products"
            v-if="productsData.length"
            :items="filtered_products"
            :headers="productDataHeader"
            :options.sync="pagination"
            :search="searchFor"
            show-select
            item-key="product_id"
            dense
            @dblclick:row="select_a_product"
          >
            <!-- :sort-by="['product_name', 'product_brand.name']" -->
          <template v-slot:item.product_name="{ item }">
            <v-badge
              inline
              tile
              content="New"
              v-if="item.created_at === item.requested_at"
            >{{ item.product_name }}</v-badge>
            <span v-else>{{ item.product_name }}</span>
          </template>
          <template v-slot:item.sku="{ item }">
            <span class="text-truncate">{{ item.sku }}</span>
          </template>
          <template v-slot:item.ean="{ item }">
            <span class="text-truncate">{{ item.ean }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-switch
              :input-value="item.status"
              :label="(item.status === 2) ? 'Complete' : 'Pending'"
              inset
              hide-details
              dense
              :false-value="0"
              :true-value="2"
              @change="change_product_status(item)"
              class="mt-0 pt-0"
            ></v-switch>
            <!-- <v-btn
              text
              color="primary"
              class="m-w"
              @click.stop="deleteRowOfProductList( index )"
            >
              <v-icon>close</v-icon>
            </v-btn> -->
          </template>
          </v-data-table>
          <div class="d-flex flex-row mt-2">
            <v-spacer></v-spacer>
            <v-select
              label="Select a product to keep after merge products"
              :items="selected_products"
              v-model="survived_product"
              item-text="product_name"
              item-value="product_id"
              outlined
              hide-details
            ></v-select>
              <!-- style="width: 200px" -->
            <v-spacer></v-spacer>
            <v-btn
            color="red darken-3"
            x-large
            @click="merge_products"
            disabled
            >Merge
            <v-icon>merge_type</v-icon>
            <!-- :disabled="!(selected_products.length && selected_products.map(p => p.product_id).includes(survived_product))" -->
            </v-btn>
            <v-spacer></v-spacer>
          </div>
        </template>
      </ex-card>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
/* eslint-disable */

export default {
  name: "N_ProductListTable",
  // props: ['new_product_id'],
  // props: {
  //   clientName: {
  //     type: String,
  //     default: "",
  //   },
  //   productsData: {
  //     type: Array,
  //     default: null,
  //   },
  // },
  data: () => ({
    searchFor: '',
    selected_products: [],
    survived_product: '',
    rowsPerPageItems: [50, 100, 200, 400],
    pagination: {
      rowsPerPage: 200,
    },
    selected_brand: null,
    productDataHeader: [
      {
        text: "Product brand",
        align: "left",
        class: "title",
        sortable: true,
        value: "product_brand.name",
        filterable: true,
        class: "subtitle-1"
      },
      {
        text: "Product Name",
        align: "left",
        sortable: true,
        class: "title",
        value: "product_name",
        filterable: true,
        class: "subtitle-1"
      },
      {
        text: "SKU",
        align: "left",
        sortable: true,
        class: "title",
        value: "sku",
        filterable: false,
        class: "subtitle-1"
      },
      {
        text: "EAN",
        align: "left",
        sortable: true,
        class: "title",
        value: "ean",
        filterable: false,
        class: "subtitle-1"
      },
      {
        text: "Requested_at",
        align: "left",
        sortable: true,
        class: "title",
        value: "requested_at",
        filterable: true,
        class: "subtitle-1",
        sort: (a, b) => {
          const dateA = new Date(a.split('/').reverse().join('/'));
          const dateB = new Date(b.split('/').reverse().join('/'));
          return dateA - dateB;
        }
      },
      {
        text: "Actions",
        align: "left",
        sortable: false,
        class: "title",
        value: "actions",
        filterable: false,
        class: "subtitle-1"
      },
    ],
  }),
  methods: {
    // select_a_product(a, b){
    //   console.log('a', a)
    //   console.log('b', b)
    //   console.log('b.item', b.item)
    // },
    select_a_product(event, row) {
      const product_id = row.item.product_id
      this.reset_conflicts_and_valids();
      this.$emit('select_a_product', product_id);
      this.$emit('closeProductList');
    },
    reset_conflicts_and_valids () {
      this.$store.commit('productionModule/SET_PRODUCTION_STATE', {key: 'products_ids_with_conflict', value: [] });
      this.$store.commit('productionModule/SET_PRODUCTION_STATE', {key: 'valid_domains_urls', value: [] });
      this.$store.commit('productionModule/SET_PRODUCTION_STATE', {key: 'invalid_domains_urls', value: [] });
      this.$store.commit('productionModule/SET_PRODUCTION_STATE', {key: 'fetched_products_info', value: [] });
      this.$store.commit('productionModule/SET_PRODUCTION_STATE', {key: 'showConflict', value: false });
    },
    deleteRowOfProductList ( product_list_index ) {
      console.log('delete item', product_list_index)
      this.$store.commit('productionModule/REMOVE_PRODUCT', product_list_index );
    },
    deleteByProductId (deleted_products) {
      deleted_products.forEach(element => {
        let index = this.filtered_products.map(x => x.product_id).indexOf(parseInt(element));
        // console.log('element', element)
        // console.log('array', this.filtered_products.map(x => x.product_id))
        // console.log('index', index)
        this.deleteRowOfProductList(index);
      });
    },
    merge_products() {
      const data = {
        task: "merge_products",
        payload: {
          deleted_products: this.selected_products.map(p => p.product_id).filter(f => f!==this.survived_product),
          merge_to_product: this.survived_product,
        }
      }
      console.log('data', data)
      this.$store.dispatch('productionModule/general_api', data ).then(res => {
        console.log('results.data', res.data);
        this.deleteByProductId(res.data.deleted_products);
      })
    },
    sort_by_name_brand (a , b) {
      // 'product_name', 'product_brand.name'
      return a.product_name - b.product_name;
    },
    change_product_status( item ) {
      const new_status = (item.status === 2) ? 0 : 2;
      const data = {
        task: "change_product_status",
        payload: {
          product_id: item.product_id,
          status: new_status,
          }
      };
      this.$store.dispatch("productionModule/general_api", data)
      .then( res => {
        console.log( 'find_product_status results', res.data );
        // this.product_status = res.data.payload.status;
        const obj = {id: item.product_id, status: new_status};
        this.$store.commit("productionModule/UPDATE_LOADED_PRODUCTS_STATUS", obj);
      }).finally(() => {});
    },
  },
  computed: {
    clientName () {
      const client = this.$store.state.productionModule.clients_list
              .find(clients => clients.value == this.$store.state.productionModule.product_filter.selected_client)
      return (client !== undefined) ? client.text : undefined;
    },
    productsData () {
      return this.$store.state.productionModule.loaded_products;
    },
    selected_product_id () {
      return this.$store.state.productionModule.selected_product.id;
    },
    filtered_products() {
      const products = (!!this.selected_brand)
        ? this.productsData.filter(p => p.product_brand.id === this.selected_brand)
        : this.productsData
      return products//.sort((a, b) => a.product_name.toLowerCase() - b.product_name.toLowerCase())
    },
    brands() {
      const brands = this.productsData.map(p => p.product_brand)
      const unique_brands = new Set(brands)
      return [{name: 'All brands', id: null}, ...unique_brands];
    },
  },
  mounted() {
    if(!this.selected_product_id && !!this.productsData){
      // this.loadProduct(this.productsData[0].product_id)
      this.$emit('select_a_product', this.productsData[0].product_id);
    }
  },
};
</script>

<style scoped>
.autocom-width {
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/production/N_ProductListTable.vue